var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMexico(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "tiny",
    viewBox: "0 0 800 440",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mexico"
  }, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("image", {
    width: 200,
    height: 200,
    x: "190px",
    href: "img/img01.jpg",
    clipPath: "url(#image-mask)",
    preserveAspectRatio: "xMidYMid slice"
  }), /*#__PURE__*/React.createElement("image", {
    width: 200,
    height: 200,
    x: "250px",
    y: "75px",
    href: "img/img02.jpg",
    clipPath: "url(#image-mask2)",
    preserveAspectRatio: "xMidYMid slice"
  }), /*#__PURE__*/React.createElement("image", {
    width: 200,
    height: 200,
    x: "275px",
    y: "245px",
    href: "img/img03.jpg",
    clipPath: "url(#image-mask3)",
    preserveAspectRatio: "xMidYMid slice"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    className: "noFill",
    d: "M 380.37 89.16 370.49 146.69 287.29 173.54 249.21 140.07 242.81 30.33 380.37 89.16 Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    className: "noFill",
    d: "M 370.49 146.69 396.48 188.58 354.08 255.68 327.74 238.65 287.29 173.54 370.49 146.69 Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    className: "noFill",
    d: "M 394.57 273.1 416.88 265.3 425.74 271.11 410.96 306.84 375.8 342.68 346.14 337.17 330.54 299.57 355.5 257.33 394.57 273.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 89.87 1 86.05 15.55 141.59 114.5 108.83 114.5 89.87 1 Z"
  }), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("path", {
    d: "M 734.12 327.88 737.77 368.56 691.42 371.71 666.72 366.65 662.77 364.46 657.51 355.41 706.73 295.12 734.12 327.88 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 633.64 367.5 680.01 385.97 612.77 413.95 618.72 388.85 625.27 384.36 628.27 378.72 630.96 376.03 633.09 368.39 633.64 367.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 467.84 120.31 443.69 201.47 396.48 188.58 370.49 146.69 380.37 89.16 467.84 120.31 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 375.8 342.68 369.78 349.29 345.46 337.34 345.71 336.93 346.14 337.17 375.8 342.68 Z"
  }), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("path", {
    d: "M 469.5 278.78 455.03 309.26 410.96 306.84 425.74 271.11 426.1 270.83 469.5 278.78 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 476.65 348.86 487.46 358.65 503.65 370.44 500.42 409.59 408.88 366.05 448.4 344.65 476.65 348.86 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 514.76 303.48 507.93 323.64 497.57 326.49 467.44 309.76 487.74 284.15 501.64 281.45 514.76 303.48 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 467.44 309.76 497.57 326.49 497.88 330.03 498.4 341.41 489.66 339.92 482.09 338.47 476.65 348.86 448.4 344.65 460.4 315.42 467.44 309.76 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 455.03 309.26 460.4 315.42 448.4 344.65 408.88 366.05 369.78 349.29 375.8 342.68 410.96 306.84 455.03 309.26 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 489.66 339.92 498.4 341.41 487.46 358.65 476.65 348.86 482.09 338.47 489.66 339.92 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 354.08 255.68 355.5 257.33 330.54 299.57 320.81 251.37 327.74 238.65 354.08 255.68 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 467.84 120.31 470.75 122.6 461.26 234.93 445.14 203.89 443.69 201.47 467.84 120.31 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 557.63 360.53 562.76 362.98 618.72 388.85 612.77 413.95 500.42 409.59 503.65 370.44 546.48 357.06 557.63 360.53 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 546.48 357.06 503.65 370.44 487.46 358.65 498.4 341.41 497.88 330.03 507.93 323.64 514.76 303.48 546.48 357.06 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 487.74 284.15 467.44 309.76 460.4 315.42 455.03 309.26 469.5 278.78 487.74 284.15 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 737.77 368.56 734.12 327.88 778.6 278.93 737.77 368.56 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 461.26 234.93 497.44 255.79 501.64 281.45 487.74 284.15 469.5 278.78 426.1 270.83 445.14 203.89 461.26 234.93 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 287.29 173.54 327.74 238.65 320.81 251.37 233.63 157.36 249.21 140.07 287.29 173.54 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 242.81 30.33 249.21 140.07 233.63 157.36 86.05 15.55 89.87 1 242.81 30.33 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 628.27 378.72 625.27 384.36 613.09 367.85 628.27 378.72 Z M 666.72 366.65 691.42 371.71 680.01 385.97 633.64 367.5 666.72 366.65 Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 517.01 260.38 497.44 255.79 461.26 234.93 470.75 122.6 517.01 260.38 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 497.88 330.03 497.57 326.49 507.93 323.64 497.88 330.03 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 613.09 367.85 625.27 384.36 618.72 388.85 562.76 362.98 613.09 367.85 Z M 517.01 260.38 557.63 360.53 546.48 357.06 514.76 303.48 501.64 281.45 497.44 255.79 517.01 260.38 Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 778.6 278.93 734.12 327.88 706.73 295.12 706.57 295.15 706.15 295.16 778.6 278.93 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 443.69 201.47 445.14 203.89 426.1 270.83 425.74 271.11 416.88 265.3 394.57 273.1 355.5 257.33 354.08 255.68 396.48 188.58 443.69 201.47 Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "image-mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 380.37 89.16 370.49 146.69 287.29 173.54 249.21 140.07 242.81 30.33 380.37 89.16 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "image-mask2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 370.49 146.69 396.48 188.58 354.08 255.68 327.74 238.65 287.29 173.54 370.49 146.69 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "image-mask3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 394.57 273.1 416.88 265.3 425.74 271.11 410.96 306.84 375.8 342.68 346.14 337.17 330.54 299.57 355.5 257.33 394.57 273.1 Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMexico);
export default __webpack_public_path__ + "static/media/mexico.e56fa9cf5d06cade822ed3f2d853ef83.svg";
export { ForwardRef as ReactComponent };